module.exports = __webpack_public_path__ + "static/media/cloud-showers-heavy.7761521d.svg";